import React, { useState } from "react";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddShippingRate from "../../Modals/addshippingrate";

/* =======================
   SHIPPING RATES DATA
======================= */

const shippingRatesData = [
    {
        origin: "New York",
        destination: "Los Angeles",
        carrier: "FedEx",
        rate: "$150.00",
        deliveryDays: "3 - 5 days",
        status: "active",
    },
    {
        origin: "Chicago",
        destination: "Houston",
        carrier: "UPS",
        rate: "$85.00",
        deliveryDays: "2 - 4 days",
        status: "inactive",
    },
    {
        origin: "Miami",
        destination: "Seattle",
        carrier: "USPS",
        rate: "$45.00",
        deliveryDays: "5 - 7 days",
        status: "active",
    },
    {
        origin: "San Francisco",
        destination: "Las Vegas",
        carrier: "DHL",
        rate: "$120.00",
        deliveryDays: "1 - 2 days",
        status: "active",
    },
];

const ShippingRates = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* =======================
                PAGE TITLE
            ======================= */}
            <div className="main_title">
                <h1>Shipping Rates</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Shipping Rates
                </p>
            </div>

            {/* =======================
                STATS CARDS
            ======================= */}
            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Total Rates</p>
                        </h2>
                        <figure className="blue">
                            <LocalShippingOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Active Rates</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            200
                            <p>Avg Shipping Rate</p>
                        </h2>
                        <figure className="warning">
                            <LocalOfferOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            {/* =======================
                TABLE
            ======================= */}
            <div className="cards mt_20">
                <div className="table_header">
                    <Box className="search_box">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search shipping rates..."
                        />
                    </Box>


                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Origin</TableCell>
                                <TableCell>Destination</TableCell>
                                <TableCell>Carrier</TableCell>
                                <TableCell>Rate</TableCell>
                                <TableCell>Delivery Days</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {shippingRatesData
                                .filter((row) =>
                                    row.origin
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                )
                                .map((row, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>
                                            <b>{row.origin}</b>
                                        </TableCell>

                                        <TableCell>{row.destination}</TableCell>

                                        <TableCell>{row.carrier}</TableCell>

                                        <TableCell>
                                            <b>{row.rate}</b>
                                        </TableCell>

                                        <TableCell>
                                            {row.deliveryDays}
                                        </TableCell>

                                        <TableCell>
                                            <span className={`badge1 ${row.status === 'active' ? 'success' : 'danger'}`}>
                                                {row.status}
                                            </span>
                                        </TableCell>


                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <AddShippingRate
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ShippingRates;
